import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

import Input, { InputProps } from "./Input";

interface CounterInputProps extends InputProps {
    value: string;
    maxLength: number;
    boxClassName?: string;
}

const CounterInput = forwardRef<HTMLInputElement, CounterInputProps>(
    ({ value, maxLength, boxClassName, ...props }, ref) => {
        const inputStyle = twMerge("w-[240px]", props.className);

        return (
            <div className={twMerge("flex flex-1 items-center gap-[8px]", boxClassName)}>
                <Input className={inputStyle} maxLength={maxLength} {...props} ref={ref} />
                <p className="w-[76px] whitespace-nowrap text-center text-[14px]">
                    <span className="text-console">{value.length} </span> / {maxLength}
                </p>
            </div>
        );
    },
);

CounterInput.displayName = "CounterInput";
export default CounterInput;
